export {}
Set.prototype.Add = function <T>(this: Set<T>, value: T): Set<T> {
	this.add!(value)
	return this
}

Set.prototype.Delete = function <T>(this: Set<T>, value: T): bool {
	return this.delete!(value)
}

Set.prototype.Has = function <T>(this: Set<T>, value: T): bool {
	return this.has!(value)
}

Set.prototype.Clear = function <T>(this: Set<T>): void {
	this.clear()
}

Set.prototype.Size = function <T>(this: Set<T>): int {
	return this.size
}

Set.prototype.Values = function <T>(this: Set<T>): IterableIterator<T> {
	return this.values!()
}

Set.prototype.Union = function <T>(this: Set<T>, other: Set<T>): Set<T> {
	const result = new Set<T>(this)
	for (const item of other) {
		result.add!(item)
	}
	return result
}

Set.prototype.Intersection = function <T>(this: Set<T>, other: Set<T>): Set<T> {
	const result = new Set<T>()
	for (const item of this) {
		if (other.has!(item)) {
			result.add!(item)
		}
	}
	return result
}

Set.prototype.Difference = function <T>(this: Set<T>, other: Set<T>): Set<T> {
	const result = new Set<T>(this)
	for (const item of other) {
		result.delete!(item)
	}
	return result
}
